// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1t-KI","range":"MonthRangeSwitch_range__2IPF-","disabled":"MonthRangeSwitch_disabled__3Pjo_"};